import React from "react";

export const FieldLabel = ({
  children,
  ...props
}: { children: React.ReactNode } & React.HTMLAttributes<HTMLSpanElement>) => (
  <span className="text-foreground text-sm font-medium leading-5" {...props}>
    {children}
  </span>
);

export const RequiredLabel = ({ children }: { children: React.ReactNode }) => (
  <span className="text-foreground flex items-center gap-0.5 text-sm font-medium leading-5">
    {children}
    <span className="text-destructive">*</span>
  </span>
);

export const FieldError = ({ message }: { message?: string | null }) =>
  message ? <p className="mt-1 text-xs text-destructive">{message}</p> : null;
